import { render, staticRenderFns } from "./ImpactOfDisabilityWizard.vue?vue&type=template&id=a516250e&scoped=true"
import script from "./ImpactOfDisabilityWizard.vue?vue&type=script&lang=js"
export * from "./ImpactOfDisabilityWizard.vue?vue&type=script&lang=js"
import style0 from "./ImpactOfDisabilityWizard.vue?vue&type=style&index=0&id=a516250e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a516250e",
  null
  
)

export default component.exports